import React from 'react';
import { Link } from 'react-router-dom';
import StaticPage from '../../static/StaticPage';
import styles from '../../static/staticPage.module.css';

const PrivacyPolicyPage = () => {
  return (
    <StaticPage
      title="Privacy Policy"
      subtitle="Last updated: March 31, 2026. This policy explains how BarberShop collects, uses, and protects your information."
    >
      <section className={styles.section}>
        <h2>Information we collect</h2>
        <p>
          We may collect information you provide when you register, book a service, complete KYC, or
          contact support—such as name, email, phone number, address, and payment-related metadata
          handled by payment providers.
        </p>
        <p>
          We also collect technical data (device, browser, approximate location based on IP, and
          usage of our site or app) to operate and improve the service.
        </p>
      </section>
      <section className={styles.section}>
        <h2>How we use information</h2>
        <ul>
          <li>To create and manage your account and bookings</li>
          <li>To process payments and send transactional messages</li>
          <li>To personalize your experience and show relevant salons or offers</li>
          <li>To detect fraud, abuse, and security issues</li>
          <li>To comply with legal obligations</li>
        </ul>
      </section>
      <section className={styles.section}>
        <h2>Sharing</h2>
        <p>
          We share information with salons and vendors as needed to fulfill your bookings. We use
          service providers (hosting, analytics, email, maps) under contracts that require
          appropriate safeguards. We do not sell your personal information.
        </p>
      </section>
      <section className={styles.section}>
        <h2>Cookies</h2>
        <p>
          We use cookies and similar technologies for authentication, preferences, and analytics.
          You can control cookies through your browser settings; some features may not work if
          disabled.
        </p>
      </section>
      <section className={styles.section}>
        <h2>Retention &amp; security</h2>
        <p>
          We retain data as long as your account is active or as needed for legal and business
          purposes. We apply reasonable technical and organizational measures to protect data, but
          no method of transmission over the Internet is 100% secure.
        </p>
      </section>
      <section className={styles.section}>
        <h2>Your rights</h2>
        <p>
          Depending on applicable law, you may request access, correction, deletion, or restriction
          of your personal data, or object to certain processing. Use the{' '}
          <Link to="/contact">contact form</Link> or email{' '}
          <a href="mailto:info@timetofuture.com">info@timetofuture.com</a> to exercise these rights.
        </p>
      </section>
      <section className={styles.section}>
        <h2>Changes</h2>
        <p>
          We may update this policy from time to time. We will post the revised version on this page
          with a new “last updated” date.
        </p>
      </section>
    </StaticPage>
  );
};

export default PrivacyPolicyPage;
